<template>
    <div class="container">
        <div class="row pl-1">
            <button class="btn btn-primary btn-pill pl-4 pr-4" v-on:click="nuevo">Cotizar nuevo</button>
        </div>
        <div class="row pt-4" v-if="cargando">
            <spinnerPersonalizado v-for="j in numero" :key="j"></spinnerPersonalizado>
        </div>
        <div class="row pt-4" v-else>
            <boton v-for="(item,index) in lista" :key="index" :obj="item"/>
            <div class="col-12" v-if="lista.length===0">
                <div class="alert alert-light alert-elevate animated bounceIn" role="alert" >
                    <div class="alert-icon text-info"><i class="icon-xl la la-warning"></i></div>
                    <div class="alert-text text-center">
                        No tienes cotizaciones pendientes
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import boton from "../../componentes/resumen-personalizado";
    import spinnerPersonalizado from "../../componentes/spinner-personalizado"
    import * as servicios from "../../servicios";
    export default {
        name: "home",
        components:{
            boton,
            spinnerPersonalizado
        },
        data:()=>({
            lista:[],
            cargando:true,
            numero:Math.floor((Math.random() * 2) + 4),
        }),
        methods:{
            nuevo:function(){
                this.$router.push({name: 'p1' });
            },
            misCotizaciones:function(){
                this.cargando=true;
                servicios.cotizaciones.cotizaciones().then(r=>r.data).then(response=>{
                    this.cargando=false;
                    this.lista=response;
                });
            }
        },
        mounted() {
            this.misCotizaciones();
            this.$store.commit("limpiar");
        }
    }
</script>

<style scoped>

</style>
